<template>
    <div class="comment">
        <div class="f16 line22 fw600" >标题</div>
        <input type="text" id="title" v-model="title" placeholder="请输入帖子标题" maxlength="40">
        <div class="f16 line22 fw600 margint20">帖子详情</div>
        <div class="content">
          <Tinymce ref="editor" v-model="content" :height="400" />
        </div>
        <div @click="upComment" class="sub f16 margint40">发布帖子</div>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
    name: 'comment',
    data(){
        return {
            title: '',
            content: '',
            setting: {
                height: 500
            },
            uid: '',
            isSend: false,
        }
    },
    mounted(){
        this.getUserInfo().then(({uid})=>{this.uid=uid})
    },
    methods:{
        ...mapActions(['getUserInfo']),
        async upComment(){
            if(!this.$isLogin())return
            if(!this.title)return this.$alert('请输入标题')
            if(!this.content)return this.$alert('请输入帖子内容');
            if(this.isSend)return
            this.isSend = true;
            let  data  = await this.$http.post(this.$api.addTz,{
                uid: this.uid,
                title: this.title,
                content: this.content
            })
            this.$message({
                message: data.msg,
                type: 'success',
                onClose: ()=>{
                    this.isSend = false;
                    this.$router.replace('/echo')
                }
            })
            
        }

    }
}
</script>
<style lang="less" scoped>
#title{
    width: 1184px;
    height: 44px;
    border-radius: 4px;
    padding: 0 12px;
    box-sizing: border-box;
    margin-top: 8px;
    border: 1px solid #958F8F;
}
.content{
    margin-top: 8px;
}
.sub{
    width: 104px;
    height: 36px;
    text-align: center;
    line-height: 36px;
    color: white;
    background: #AD2729;
}
</style>